import React, { createContext, useContext, useMemo } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { navAuth0Context } from '../../ContextSwitcher/Context/NavAuthProvider';
import { IUtilityTrayOptions } from '../../types';

const UtilityTrayContext = createContext<IUtilityTrayOptions & { showOgAssist?: boolean }>(null);
export const useUtilityTrayContext = () => useContext(UtilityTrayContext);

interface IUtilityTrayDataProviderProps {
  value: IUtilityTrayOptions & { showOgAssist?: boolean };
  children: React.ReactNode;
}

export const UtilityTrayProvider: React.FC<IUtilityTrayDataProviderProps> = ({ value, children }) => {
  const { logout } = useAuth0(navAuth0Context);
  const { profileSettingsOptions, showOgAssist, ...rest } = value ?? {};
  const modifiedProfileSettingsOptions = useMemo(
    () =>
      profileSettingsOptions?.handleSignOut
        ? {
            ...profileSettingsOptions,
            handleSignOut: async () => {
              value.profileSettingsOptions.handleSignOut();
              await logout({ openUrl: false });
            }
          }
        : value?.profileSettingsOptions,
    [profileSettingsOptions, logout]
  );
  const contextValue = useMemo(
    () => ({ ...rest, showOgAssist, profileSettingsOptions: modifiedProfileSettingsOptions }),
    [rest, showOgAssist, modifiedProfileSettingsOptions]
  );
  return <UtilityTrayContext.Provider value={contextValue}>{children}</UtilityTrayContext.Provider>;
};
